import script from "./AlertBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertBox.vue?vue&type=script&lang=ts&setup=true"

import "./AlertBox.vue?vue&type=style&index=0&id=96cdc084&lang=css"

const __exports__ = script;

export default __exports__